<template>
    <main class="a-icb a-main" id="a-icb">
        <div class="a-main__container">
            <div class="a-main__title a-icb__title">
                {{ title }}
            </div>
            <div class="a-icb__component">
                <loader v-if="reportListIsLoading" />
                <error v-if="reportListError" />
                <report-block v-if="reportList"
                    :report-data="reportData"
                    :list="reportList"
                    :mobile-device="mobileDevice"
                    @list-option-selected="reportListOptionSelected"
                    @list-date-selected="reportListDateSelected" />
            </div>
            <overview
                v-if="jsonObzorRynka"
                :overview-data="overviewData"
                :json-overview-data="jsonObzorRynka" />
            <div class="a-icb__component">
                <loader v-if="pressReleaseIsLoading" />
                <error v-if="pressReleaseError" />
                <news
                    v-if="pressRelease"
                    :news-data="newsData"
                    :news-data-items="pressRelease" />
            </div>
            <div class="a-icb__component">
                <loader v-if="researchIsLoading" />
                <error v-if="researchError" />
                <research v-if="research"
                    :desktop-small-device="desktopSmallDevice"
                    :desktop-device="desktopDevice"
                    :mobile-device="mobileDevice"
                    :research-data-items="research"
                    :research-data="researchData"
                    @option-selected="optionSelected"
                    @date-selected="dateSelected"
                    @show-more-press="showMorePress" />
            </div>
        </div>
    </main>
</template>

<script>
    import Loader from '../Loader'
    import Error from '../Error' 
    import ReportBlock from '../ReportBlock'
    import Overview from '../Overview'
    import News from '../News'
    import Research from '../Research'
    import headerSearchHandler from '../../modules/a-main-nav'
    import {pressReleaseActionTypes} from '../../store/modules/press-release'
    import {researchActionTypes} from '../../store/modules/research'
    import {reportListActionTypes} from '../../store/modules/report'
    import {mapState} from 'vuex'

    export default {
        name: 'Icb',
        components: {
            ReportBlock,
            Overview,
            News,
            Research,
            Loader,
            Error
        },
        data() {
            return {
                title: 'Ипотечные облигации',
                apiPressRelease: '/api/v2/content/analytics/press-release/',
                apiResearch: '/api/v2/content/analytics/list/',
                reportListFrom: '',
                reportListTo: '',
                dateFrom: '',
                dateTo: '',
                pageParams: '',
                jsonObzorRynka: null,
                reportData: {
                    title: 'Обзоры рынка ипотечных облигаций',
                    desc: 'Основные показатели рынка ипотечных облигаций: объем рынка, доходности, темп досрочного погашения.',
                    button: {
                        href: '/analytics/archive/?section=835',
                        text: 'Архив отчетов'
                    }
                },
                overviewData: {
                    imageData: {
                        src: '/static/v2/src/img/analytics/overview/ipotechnye-obligacyi',
                        alt: 'Рынок жилья',
                        width: '935',
                        height: '583'
                    },
                },
                newsData: {
                    title: 'Пресс-релизы',
                    button: {
                        text: 'Все пресс-релизы',
                        href: '/analytics/analytical-center/'
                    },
                },
                researchData: {
                    title: 'Тематические исследования',
                    link: {
                        href: '/analytics/archive/',
                        title: 'Архив исследований',
                    },
                },
            }
        },
        computed: {
            ...mapState({
                pressReleaseIsLoading: state => state.pressRelease.isLoading,
                pressRelease: state => state.pressRelease.data,
                pressReleaseError: state => state.pressRelease.error,
                researchIsLoading: state => state.research.isLoading,
                research: state => state.research.data,
                researchError: state => state.research.error,
                reportListIsLoading: state => state.report.isLoading,
                reportList: state => state.report.data,
                reportListError: state => state.report.error
            }),
            mobileDevice () {
                return typeof window === 'object' && window.innerWidth < 768
            },
            tabletDevice () {
                return typeof window === 'object' && window.innerWidth >= 768 && window.innerWidth < 1025
            },
            desktopSmallDevice () {
                return typeof window === 'object' && window.innerWidth >= 1025 && window.innerWidth < 1200
            },
            desktopDevice () {
                return typeof window === 'object' && window.innerWidth >= 1200
            },
        },
        methods: {
            optionSelected (id) {
                this.dateFrom = ''
                this.dateTo = ''
                this.$store.dispatch(researchActionTypes.getResearch, {apiUrl: this.apiResearch, searchValue: '?section=889&include=Y'})
            },

            dateSelected (dateStart, dateEnd) {
                this.dateFrom = dateStart
                this.dateTo = dateEnd
                this.pageParams = `?section=889&date-from=${this.dateFrom}&date-to=${this.dateTo}&include=Y`
                this.$store.dispatch(researchActionTypes.getResearch, {apiUrl: this.apiResearch, searchValue: this.pageParams})
            },

            reportListOptionSelected (id) {
                this.reportListDateFrom = ''
                this.reportListDateTo = ''
                this.$store.dispatch(reportListActionTypes.getReportList, {apiUrl: this.apiResearch, listFilter: '?section=835&include=Y'})
            },

            reportListDateSelected (dateStart, dateEnd) {
                this.reportListDateFrom = dateStart
                this.reportListDateTo = dateEnd
                this.pageParams = `?section=835&date-from=${this.reportListDateFrom}&date-to=${this.reportListDateTo}&include=Y`
                this.$store.dispatch(reportListActionTypes.getReportList, {apiUrl: this.apiResearch, listFilter: this.pageParams})
            },

            showMorePress (pageCounter) {
                if (this.dateFrom) {
                    this.pageParams = `?section=835&date-from=${this.dateFrom}&date-to=${this.dateTo}&page=${pageCounter}&include=Y`
                } else {
                    this.pageParams = `?section=835&page=${pageCounter}&include=Y`
                }

                this.$store.dispatch(researchActionTypes.getMoreData, {apiUrl: this.apiResearch, searchValue: this.pageParams})
            }
        },
        mounted() {
            this.$store.dispatch(reportListActionTypes.getReportList, {apiUrl: this.apiResearch, listFilter: '?section=835&include=Y'})
            this.$store.dispatch(pressReleaseActionTypes.getPressRelease, {apiUrl: this.apiPressRelease, newsDataFilter: '?category=ИЦБ'})
            this.$store.dispatch(researchActionTypes.getResearch, {apiUrl: this.apiResearch, searchValue: '?section=889&include=Y'})
            headerSearchHandler()
        },
        beforeMount() {
            this.jsonObzorRynka = JSON.parse(document.querySelector('#app').getAttribute('mortgage-securities-report'))
            this.researchData.link.href = document.querySelector('#app').getAttribute('researchArchiveUrl')
        }
    }
</script>